import { render, staticRenderFns } from "./GiftTicketResult.vue?vue&type=template&id=230df585&"
import script from "./GiftTicketResult.vue?vue&type=script&lang=js&"
export * from "./GiftTicketResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports